import { render, staticRenderFns } from "./TrainingStatisticsDialog.vue?vue&type=template&id=744ca65a&scoped=true"
import script from "./TrainingStatisticsDialog.vue?vue&type=script&lang=js"
export * from "./TrainingStatisticsDialog.vue?vue&type=script&lang=js"
import style0 from "./TrainingStatisticsDialog.vue?vue&type=style&index=0&id=744ca65a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744ca65a",
  null
  
)

export default component.exports